export const SocialBarThemes = {
    light: 'light',
    dark: 'dark',
};
export const SocialBarIconTestHook = 'icon';
//# sourceMappingURL=consts.js.map